import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getSSSService } from "../../../services/common.service";
import { alertActions } from "../../../state/ducks/alert/actions";

export default class Questions extends Component {

  state = {
    sss: null,
  };

  getSSS() {
    this.setState({ sss: null });
    getSSSService().then(
      response => {
        if (response.success) {
          this.setState({ sss: response.data });
        } else {
          this.props.showError(response.message);
        }
      },
      error => { }
    );
  }
  componentDidMount() {
    this.getSSS();
  }


  render() {
    return (

      <div className="container-fluid">
        {/* yesil Alan*/}
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            {/* KUTU 1 */}
            <div className="row no-gutters t-kutu t-yesilCizgi">
              <div
                className="col bosluk backleft"
                style={{
                  backgroundImage: 'url("/assets/img/backgrounds/back_left_yesil.jpg")'
                }}
              >
                {/* içerikler */}
                {/* Başlık */}
                {/* Başlık */}
                <div className="row no-gutters pb-4">
                  <div clss="col-auto">
                    <i className="t-icon-question1 icon" />
                  </div>
                  <div className="col d-flex flex-column justify-content-center">
                    <div className="baslik">Sıkça Sorulan Sorular</div>

                    <Link to="/Home/AskToAgent" className="t-icButtonYesil">

                      <span>Temsilcime Sor</span>
                      <i className="t-icon-arrow-right2" />
                    </Link>
                  </div>
                </div>


                <div className="row no-gutters">
                  <div className="col-12 t-icYaziFontStandart">
                    <div className="accordion" id="sss1">


                      {this.state.sss && this.state.sss.map((item, index) => (
                        <div className="t-icSssCerceve"  key={index}>
                          <div
                            className="row no-gutters sorusatir"
                            data-toggle="collapse"
                            data-target={`#to${item.id}`}
                          >
                            <div className="col-12">
                              <strong style={{ color: `${item.renk}` }}> {item.tur}</strong>
                              <br />
                            </div>
                            <div className="col soru">
                              {item.soru}
                            </div>
                            <div className="col-auto pl-2">
                              <i className="t-icon-keyboard_arrow_down" />
                            </div>
                          </div>
                          <div className="row no-gutters pr-4">
                            <div
                              id={`to${item.id}`}
                              className="collapse"
                              data-parent="#sss1"
                            >
                              <hr />
                              <div dangerouslySetInnerHTML={{ __html: item.cevap }} />
                            </div>
                          </div>
                        </div>
                      ))}
                      

                    </div>
                  </div>
                </div>


              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 1 BİTTİ */}
          </div>
        </div>
        {/* Duyurlar Baslık*/}
        {/* duyrular Bitti*/}
        <div className="row" style={{ height: 30 }} />
      </div>

    );
  }
}
